import axios from 'axios'
import { NODE_BASE_URL, getAxiosOptions } from './serviceHelper'

export const routeService = {
  getParallelRoutes: async (user, routeTemplateId) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/template/route/parallel-routes/${routeTemplateId}`,
        getAxiosOptions(user)
      )
    ).data
  },
}
